module.exports = __webpack_public_path__ + "img/about_003.36f58a0.webp";